import { Component, OnInit } from '@angular/core'
import { ParkingService } from '../../../services/parking.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Parking, parkingsPath, ParkingType } from '@parkupp/core'
import { doc, docData } from '@angular/fire/firestore'
import { CarouselConfig } from 'ngx-bootstrap/carousel'
import { OmnisendService } from '../../../services/omnisend.service'
import { GaActionEnum, GoogleAnalyticsService } from 'ngx-google-analytics'
import { GlobalService } from '../../../services/global.service'

@Component({
    selector: 'app-parking-page',
    templateUrl: './parking-page.component.html',
    styleUrls: ['./parking-page.component.scss'],
    providers: [
        {
            provide: CarouselConfig,
            useValue: { showIndicators: true, interval: 0, indicatorsByChunk: true, isAnimated: true },
        },
    ],
})
export class ParkingPageComponent implements OnInit {
    readonly ParkingType = ParkingType

    parkingKey: string
    parking: Parking
    productViewed = false

    constructor(
        private omnisendService: OmnisendService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private parkingService: ParkingService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public globalService: GlobalService
    ) {
        this.parkingKey = this.activatedRoute.snapshot.params['parkingKey']

        docData(doc(this.parkingService.firestore, parkingsPath(), this.parkingKey)).subscribe((documentData: any) => {
            this.parking = new Parking(documentData)
            this.parking.$key = this.parkingKey

            // Track product viewed
            if (!this.productViewed) {
                this.omnisendService.productView(this.parking)
                this.googleAnalyticsService.event(GaActionEnum.VIEW_ITEM, this.parking.parkingType, this.parking.title)
                this.productViewed = true
            }
        })

        // Whitelabel
        // if (this.globalService.subdomain == 'redefine') {
        //     document.documentElement.style.setProperty('--background-color', 'white')
        // } else {
        //     document.documentElement.style.setProperty('--background-color', '#F7F7F7')
        // }
    }

    ngOnInit(): void {}
}
